<template>
	<div class="grid-flex-container">
		<div class="grid-toolbar" v-if="report">
			<span class="view-title">{{ report.Name || '' }}</span>
			<quick-filter
				:Columns="filterFields"
				:filter="quickFilter"
				@filterChanged="onQuickFilterChanged"
			/>
			<v-badge
				:value="advancedFilter.FiltersCount > 0"
				left
				bordered
				overlap
				class="mr-2"
			>
				<template v-slot:badge>
					<span style="color: white">{{
						advancedFilter.FiltersCount
					}}</span>
				</template>
				<v-btn color="primary" @click="onShowAdvancedFilter">
					<v-icon class="mr-1">mdi-magnify</v-icon>
					Advanced search
				</v-btn>
			</v-badge>
			<!-- Desktop Export Modal (≥lg) -->
			<export-modal
				class="d-flex"
				:timezone-options="true"
				:execution-options="false"
				:data-scope-options="true"
				@exportModalEvent="onExportModalEvent"
			>
				<template #activator="{ on, attrs }">
					<v-btn
						v-bind="attrs"
						v-on="on"
						class="export"
						color="primary"
					>
						<v-icon class="mr-1">mdi-cloud-download</v-icon>
						Export
					</v-btn>
				</template>
			</export-modal>
			<filters-dialog
				v-if="showAdvancedFilter"
				:dialog="showAdvancedFilter"
				:filter="advancedFilter"
				:columns="filterFields"
				@filterChanged="onAdvancedFilterChanged"
			/>
		</div>

		<div class="generic-grid-container">
			<report-preview-custom-data :report="report" v-if="report" />
		</div>
	</div>
</template>

<script>
import ReportPreviewCustomData from '../../tools/reportBuilder/reportDetails/reportPreview/ReportPreviewCustomData.vue';
import { ReportPreviewActions } from '../../../store/actions';
import { ReportPreviewGetters } from '../../../store/getters';
import { mapGetters } from 'vuex';
import ExportModal from '../../shared/export/ExportModal.vue';
import QuickFilter from '../../shared/gridViews/QuickFilter.vue';
import FiltersDialog from '../../shared/gridViews/FiltersDialog.vue';

export default {
	name: 'ReportGridCustom',
	components: {
		ReportPreviewCustomData,
		ExportModal,
		QuickFilter,
		FiltersDialog,
	},
	computed: {
		...mapGetters({
			report: [ReportPreviewGetters.REPORT],
			columns: [ReportPreviewGetters.REPORT_COLUMNS_CUSTOM],
			quickFilter: [ReportPreviewGetters.QUICKFILTER],
			advancedFilter: [ReportPreviewGetters.ADVANCEDFILTER],
		}),
		filterFields() {
			return this.columns.map((c) => ({
				Id: c.Id,
				Label: c.Header,
				DataField: c.DataField,
			}));
		},
		currentReportId() {
			return this.$route.params.reportId;
		},
	},
	data() {
		return {
			dotsMenuOpen: false,
			showAdvancedFilter: false,
		};
	},
	mounted() {
		if (this.currentReportId) {
			this.$store.dispatch(
				ReportPreviewActions.LOAD_REPORT_BY_ID,
				this.currentReportId
			);
		}
	},
	destroyed() {
		this.$store.dispatch(ReportPreviewActions.CLEAR);
	},
	methods: {
		onQuickFilterChanged(value) {
			this.$store.dispatch(
				ReportPreviewActions.UPDATE_QUICK_FILTER,
				value
			);
		},
		onShowAdvancedFilter() {
			this.showAdvancedFilter = true;
		},
		onAdvancedFilterChanged(value) {
			this.showAdvancedFilter = false;
			this.$store.dispatch(
				ReportPreviewActions.UPDATE_ADVANCED_FILTER,
				value
			);
		},
		onExportModalEvent(exportConfig) {
			this.$store.dispatch(ReportPreviewActions.EXPORT_CUSTOM_DATA, {
				allData: exportConfig.allData,
				isDirectMode: !exportConfig.isBackgroundExport,
			});
		},
		onExportModalEventFromDots(exportConfig) {
			this.dotsMenuOpen = false;
			this.onExportModalEvent(exportConfig);
		},
	},
};
</script>
